import { Stack, TextField, InputAdornment, Chip, Box, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { COMPONENT_STATUSES, COMPONENT_STATUS_LABEL, COMPONENT_STATUS_COLOR } from '../../utils/constants';

// FEAT-002 검색 + 상태 필터.
// 검색 = 행 헤더 (제품명 / 기능명) 매칭 (US-005, EC-05 AND 동작)
// 상태 필터 = 다중 선택 (Chip toggle), 관점 2 에서만 의미. 관점 1 에서는 숨김.
export default function MatrixFilter({
  variant,
  search,
  onSearchChange,
  selectedStatuses,
  onToggleStatus,
}) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignItems={{ xs: 'stretch', md: 'center' }}
      sx={{ mb: 2 }}
    >
      <TextField
        size="small"
        placeholder={variant === 'product-sw' ? '검색: 제품명...' : '검색: 기능명...'}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{ width: { xs: '100%', md: 360 } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />

      {variant === 'feature-sw-version' && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            상태 필터:
          </Typography>
          {COMPONENT_STATUSES.map((s) => {
            const active = selectedStatuses.includes(s);
            return (
              <Chip
                key={s}
                label={COMPONENT_STATUS_LABEL[s]}
                size="small"
                color={active ? COMPONENT_STATUS_COLOR[s] : 'default'}
                variant={active ? 'filled' : 'outlined'}
                onClick={() => onToggleStatus(s)}
                sx={{ cursor: 'pointer' }}
              />
            );
          })}
        </Box>
      )}
    </Stack>
  );
}
